import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import ActionInfo from '@mui/icons-material/Info';
import Chip from '@mui/material/Chip';
import { red } from '@mui/material/colors';

const styles = {
  avatar: { display: 'block' },
  backgroundColor: red['500'],
  infoIcon: {
    width: 38,
    height: 38,
    margin: '0 0 0',
  },
};

interface AlertMessageProps {
  children: JSX.Element | string;
}

const AlertMessage = ({ children }: AlertMessageProps) => {
  return (
    <Chip
      color="default"
      label={children}
      avatar={
        <Avatar
          style={{
            width: 32,
            height: 32,
            margin: '0 0 0',
          }}
          children={<ActionInfo style={styles.infoIcon} />}
        />
      }
    />
  );
};

export default AlertMessage;
